import React from 'react';
import Dialog from '@dashboard/components/Dialog';
import { Form } from '@dashboard/components/Formik';
import { useUpdateBlockedEmailNote } from '@dashboard/hooks/useBlockedEmails';

const BlockedCustomerEditDialog = ({ open, onClose, blockedCustomer }) => {
  const updateNote = useUpdateBlockedEmailNote({ onSuccess: onClose });

  return (
    <Dialog
      title="Edit reason"
      cancelButton={null}
      confirmButton={null}
      size="lg"
      open={open}
      onCancel={onClose}
      description="Update the reason for blocking this email."
    >
      <Form
        showState={false}
        initialValues={{ email: blockedCustomer?.email ?? '', note: blockedCustomer?.note ?? '' }}
        onSubmit={async values => {
          try {
            const data = await updateNote.mutateAsync({
              blockedCustomerId: blockedCustomer.id,
              note: values.note?.trim() ?? '',
            });
            return { data };
          } catch (error) {
            return { error };
          }
        }}
        fields={() => [
          {
            name: 'email',
            label: 'Email address',
            type: 'email',
            disabled: true,
          },
          {
            name: 'note',
            label: 'Reason',
            type: 'textarea',
            placeholder: 'Add a reason for blocking this email',
            helpText: 'Only you and your team can see this.',
            rows: 3,
          },
        ]}
        formSubmitAlign="end"
        submitButton={{ label: 'Save reason', appearance: 'primary' }}
        cancelButton={{ label: 'Cancel', appearance: 'secondary', onClick: onClose }}
      />
    </Dialog>
  );
};

export default BlockedCustomerEditDialog;
